import { isEqual } from 'lodash';
import { Editor, Element, Path } from 'slate';
import type { NodeEntry, Point, Text } from 'slate';

import { slateToMarkdown } from 'bundles/cml/editor/utils/slateToMarkdown';
import type { BlockElement } from 'bundles/cml/shared/types/elementTypes';

export const isAIButtonDisabled = (editor: Editor): boolean => {
  const text = editor.selection ? Editor.string(editor, editor.selection) : '';
  if (!text) {
    return true;
  }

  return false;
};

const getText = ([{ text }, path]: NodeEntry<Text>, start: Point, end: Point): string => {
  if (Path.isBefore(path, start.path) || Path.isAfter(path, end.path)) {
    return '';
  }

  const isStartPath = isEqual(path, start.path) && start.offset > 0;
  const isEndPath = isEqual(path, end.path) && end.offset > 0;

  if (isStartPath || isEndPath) {
    const startIndex = isStartPath ? start.offset : 0;
    const endIndex = isEndPath ? end.offset : undefined;
    return text.slice(startIndex, endIndex);
  }

  return text;
};

export const getSelectedText = (editor: Editor) => {
  if (!editor.selection) {
    return {};
  }

  const start = Editor.start(editor, editor.selection);
  const end = Editor.end(editor, editor.selection);

  const nodes = Array.from(
    Editor.nodes<BlockElement>(editor, {
      match: (node, path) => Element.isElement(node) && path.length === 1,
    })
  );

  const markdownNodes = nodes.flatMap((node) => slateToMarkdown(node, (entry) => getText(entry, start, end))).flat();
  const selectedText = markdownNodes.join('\n');

  const completeText = editor.children
    .flatMap((node, index: number) => {
      return slateToMarkdown([node as BlockElement, [index]]);
    })
    .join('\n');

  const startIndex = completeText.indexOf(selectedText);
  const endIndex = startIndex + selectedText.length;

  if (startIndex === -1) {
    return { completeText: selectedText, startIndex: 0, endIndex };
  }

  return { completeText, startIndex, endIndex };
};
